<ng-container i18n>To:</ng-container>
<ng-container>{{ contact }}</ng-container>
